import Vue from 'vue'
import dayjs from 'dayjs' // 时间转换
// import md5 from 'md5'
import langList from '~/static/json/languageList.json'
import areaCodeCN from '~/static/json/areaCodeCN.json'
const offsetGMT = new Date().getTimezoneOffset() * 60 * 1000
const now = new Date().getTime() - offsetGMT
// lodash一些实用方法：
// _.add(number1, number2) // 两数相加
// _.subtract(number1, number2) // 两数相减
// _.multiply(number1, number2) // 两数相乘
// _.divide(number1, number2) // 两数相除
// _.ceil(number, 2) // 根据精度值向上舍入number
// _.floor(number, 2) // 根据精度值向下舍入number
// _.round(number, 2) // 根据精度值四舍五入number
// _.max(array) // 计算简单数组中的最大值
// _.min(array) // 计算简单数组中的最小值
// _.sum(array) // 计算简单数组值的总和
// _.sumBy([{ n: 1 }, { n: 2 }], 'n') // 根据第二个参数值作为条件返回总和
// _.maxBy([{ n: 1 }, { n: 2 }], 'n') // 根据第二个参数值作为条件返回最大的值
// _.minBy([{ n: 1 }, { n: 2 }], 'n') // 根据第二个参数值作为条件返回最小的值
// _.cloneDeep([{ n: 1 }, { n: 2 }]) // 深拷贝
// _.split('a-b-c', '-', 2) // 根据分隔符拆分字符串，并限制返回数组的长度

// 公用方法
export const currProject = {
  // // PC禁止页面滚动
  // stopMove () {
  //   const m = function (e) { e.preventDefault() }
  //   document.body.style.overflow = 'hidden'
  //   document.addEventListener('touchmove', m, { passive: false })// 禁止页面滑动
  // },
  // // PC开启页面滚动
  // Move () {
  //   const m = function (e) { e.preventDefault() }
  //   document.body.style.overflow = 'auto'// 出现滚动条
  //   document.removeEventListener('touchmove', m, { passive: true })
  // },
  appTime(timestamp, type = 0, timezoom = '') {
    function getYesterdayMidnight(d) {
      const today = new Date() // 获取当前日期
      today.setHours(0, 0, 0, 0) // 设置今天的时间为 00:00
      today.setDate(today.getDate() - d) // 减去一天，得到昨天的日期
      return today.getTime() // 返回昨天 00:00 的时间戳（毫秒）
    }
    if (!timestamp) return ''
    if (String(timestamp)?.length <= 10) timestamp *= 1000 // 转换秒级时间戳到毫秒级
    timestamp = +timestamp
    const now = dayjs()
    const targetTime = dayjs(timestamp)
    // 计算两个日期之间的差值
    const diffSeconds = now.diff(targetTime, 'second')
    const diffMinutes = now.diff(targetTime, 'minute')
    const diffHours = now.diff(targetTime, 'hour')
    const diffDays = now.diff(targetTime, 'day')
    // 判断当前语言
    const lang = this.$store.state.LanguageCode
    const isChinese = ['zh-cn', 'zh'].includes(lang?.toLowerCase())
    const isZhCN = ['zh-cn'].includes(lang?.toLowerCase())
    const isZh = ['zh'].includes(lang?.toLowerCase())
    // 判断时间范围
    const yd = getYesterdayMidnight(1) // 昨天0点
    const ld = getYesterdayMidnight(2) // 前天0点
    // 将毫秒转换为总秒数
    const timer = new Date(timestamp - offsetGMT)

    const yyyy = timer.getUTCFullYear() // 年
    // const curYear = new Date().getUTCFullYear() // 年
    const mm = timer.getUTCMonth() + 1 > 9 ? timer.getUTCMonth() + 1 : '0' + (timer.getUTCMonth() + 1) // 月
    const dd = timer.getUTCDate() > 9 ? timer.getUTCDate() : '0' + timer.getUTCDate() // 日
    const hh = timer.getUTCHours() > 9 ? timer.getUTCHours() : '0' + timer.getUTCHours() // 时
    const min = timer.getUTCMinutes() > 9 ? timer.getUTCMinutes() : '0' + timer.getUTCMinutes() // 分
    const ss = timer.getUTCSeconds() > 9 ? timer.getUTCSeconds() : '0' + timer.getUTCSeconds() // 秒

    const hhms = hh + ':' + min

    let time = ''
    if (type == 0) {
      if (diffSeconds < 660) {
        return isZhCN ? '刚刚' : isZh ? '剛剛' : '1m'
      } else if (diffMinutes < 60) {
        const str = isZhCN ? '{0}分钟前' : isZh ? '{0}分鐘前' : '{0}m'
        return str?.replace('{0}', String(diffMinutes))
      } else if (diffHours < 24) {
        const str = isZhCN ? '{0}小时前' : isZh ? '{0}小時前' : '{0}h'
        return str?.replace('{0}', String(diffHours))
      } else if (diffDays < 2 && yd < timestamp) {
        return isChinese ? '昨天' + ' ' + hhms : 'Yesterday' + ' ' + hhms
      } else if (diffDays < 3 && yd >= timestamp && ld < timestamp) {
        return isChinese ? '2天前' : 'Two days ago'
      } else if (diffDays < 4) {
        return isChinese ? '3天前' : 'Three days ago'
      } else if (diffDays < 8) {
        return isZhCN ? '1周内' : isZh ? '1週內' : 'In a week'
      } else if (dayjs().year() == targetTime.year()) {
        return targetTime.format('MM-DD') // 当年的情况
      }
      return targetTime.format('YYYY-MM-DD') // 不同年份的情况
    } else if (type == 1) {
      time = `${yyyy}-${mm}-${dd}`
    } else if (type == 2) {
      time = `${hh}:${min}:${ss}`
    } else if (type == 3) {
      time = `${hh}:${min}`
    } else if (type == 4) {
      time = `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`
    } else if (type == 5) {
      time = `${yyyy}-${mm}-${dd} ${hh}:${min}`
    } else if (type == 6) {
      time = `${yyyy}-${mm}-${dd}(UTC${timezoom}) ${hh}:${min}`
    }
    return time
  },
  getBrokerDomain(vux) {
    let secondDomain = 'broker'
    if (vux.host.includes('info')) {
      secondDomain = 'info'
    }
    return vux.host.includes('192.168') || vux.host.includes('localhost') ? 'http://localhost:80' : `https://${secondDomain}.${vux.newhost}.com`
  },

  getwwwDomain(vux) {
    return vux.host.includes('192.168') || vux.host.includes('localhost') ? 'http://localhost:3000' : `https://www.${vux.newhost}.${vux.suffix}`
    // return `https://www.${vux.newhost}.hk`
  },

  getSuffix(vux) {
    return vux.suffix
  },

  setRating(v) {
    if (v > 8.54) {
      return 'AAA'
    } else if (v >= 8) {
      return 'AA'
    } else if (v >= 7) {
      return 'A'
    } else if (v >= 6) {
      return 'B'
    } else if (v >= 4.56) {
      return 'C'
    } else if (v <= 4.55 && v > 0) {
      return 'D'
    } else {
      return 'E'
    }
  },
  // 相同交易商名字
  getshortName(sName, sName1) {
    // shortName 放前面 localShortName放后面
    if (sName == sName1) {
      return sName
    } else {
      return `${sName || ''} ${sName1 || ''}`
    }
  },
  // 只取交易商简称
  getOnlyShortName(sName, sName1) {
    if (!sName) {
      return sName1
    } else {
      return sName
    }
  },
  // 数字千分位展示
  num2CurrencyNo(value = 0) {
    if (!value) return 0
    const intPart = Math.trunc(value) // 获取整数部分
    const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 整数部分处理，增加,
    let floatPart = '' // 预定义小数部分
    const valueArray = value.toString().split('.') // 将数值截取为小数部分和整数部分
    if (valueArray.length == 2) {
      // 有小数部分
      floatPart = valueArray[1].toString() // 取得小数部分
      return intPartFormat + '.' + floatPart
    }
    return intPartFormat + floatPart
  },
  // 当前选择的语言code
  currLangCode() {
    return this.$store.state.LanguageCode || 'en'
  },
  // 当前选择的国家code
  currCountry(key = '') {
    let obj = this.$store.state?.getCountry
    const myCountry = this.$store.state?.myCountry
    const CountryCode = this.$store.state?.CountryCode
    if (obj.countryCode == '156') {
      obj = {
        code: '156',
        twoCharCode: 'CN',
        name: myCountry == 'cn' || myCountry == 'hk' || CountryCode == 'cn' || CountryCode == 'hk' ? '中国香港' : '香港',
        flag: 'https://img.souhei.com.cn/flags/344.png_wiki-template-global',
        'flag-c': 'https://img.souhei.com.cn/flags/344.png_wiki-template-global'
      }
    } else if (obj.countryCode == '158') {
      obj = {
        twoCharCode: 'TW',
        code: '158',
        name: myCountry == 'cn' || myCountry == 'hk' || CountryCode == 'cn' || CountryCode == 'hk' ? '中国台湾' : '台湾',
        flag: 'https://img.souhei.com.cn/flags/158.png_wiki-template-global',
        'flag-c': 'https://img.souhei.com.cn/flags/158.png_wiki-template-global'
      }
    } else {
      obj = {
        code: obj.countryCode,
        twoCharCode: obj.twoCharCode,
        name: obj.countryCode == '344' ? obj.name.replace('中国', '').replace('中國', '').replace('China', '') : obj.name,
        flag: obj.flag,
        'flag-c': obj.flag
      }
    }
    if (!key) return obj
    return obj[key] || ''
  },
  // 真实的国家code
  realuserCountry(key = '') {
    let obj = this.$store.state?.usergetCountry
    if (obj.countryCode == '156') {
      obj = {
        code: '156',
        twoCharCode: 'CN',
        name: '中国香港',
        flag: 'https://img.souhei.com.cn/flags/344.png_wiki-template-global',
        'flag-c': 'https://img.souhei.com.cn/flags/344.png_wiki-template-global'
      }
    } else {
      obj = {
        code: obj.countryCode,
        twoCharCode: obj.twoCharCode,
        name: obj.countryCode == '344' || obj.countryCode == '158' ? obj.name.replace('中国', '').replace('中國', '').replace('China', '') : obj.name,
        flag: obj.flag,
        'flag-c': obj.flag
      }
    }
    if (!key) return obj
    return obj[key] || ''
  },
  // 用户所在的国家简称（如CN）
  userCountry() {
    return this.$store.state.myCountry
  },
  // 获取用户选择的语言信息
  getMyLang(obj = {}) {
    const key = Object.keys(obj)[0]
    const result = langList?.find((item) => item[key] == obj[key])
    return result || {}
  },
  // 获取用户所在的国家信息
  getMyCountry(obj = {}) {
    const key = Object.keys(obj)[0]
    if (areaCodeCN) {
      for (let i = 0; i < areaCodeCN.length; i++) {
        const result = areaCodeCN[i]?.data?.find((each) => each[key] == obj[key])
        if (!result) continue
        return result
      }
    }
    return {} // 未找到结果，返回空对象
  },
  // 涨跌（绿涨红跌/红涨绿跌）
  riseFn(value = 0) {
    const isChina = ['156', '158', '344'].includes(String(this.$store.state?.getCountry?.countryCode))
    return isChina ? (value > 0 ? -1 : value < 0 ? 1 : 0) : value > 0 ? 1 : value < 0 ? -1 : 0
  },
  // 字符串过滤表情包
  filterEmoji(str = '', isbool = false) {
    // 只匹配img、br、hr、input标签
    const reg2 = new RegExp('<(img|br|hr|input)[^>]*>', 'gi') // eslint-disable-line
    // 分组匹配，过滤全部的html标签，包括内容
    // const reg3 = new RegExp('<(\\S*)[^>]*>[^<]*<\\/(\\1)>', 'gi') // eslint-disable-line
    return filterHtmlOrContainer(str, isbool)
    // str需要过滤的字符串，isbool为false则需要单标签过滤、为true则不需要单标签过滤
    function filterHtmlOrContainer(str, isbool) {
      if (typeof str != 'string') return str // 不是字符串
      let result = str
      if (!isbool) result = result.replace(reg2, '') // 先过滤单标签
      // result = result.replace(reg3, '') // 先通过分组匹配，把双标签去除，若是是嵌套标签，则会先将嵌套标签内的双标签过滤掉
      // if (reg3.test(result)) return filterHtmlOrContainer(result, true) // 若为true，则表明还有标签
      // else return result
      return result
    }
  },
  momentTime(timestamp, type = 0, timezoom) {
    // timestamp传时间戳--格式化时间type为0默认，实堪=1；快讯为2；财经日历为3
    // console.log(offsetGMT, 9199, new Date().getTimezoneOffset(), new Date(now))
    if (!timestamp) return
    if (String(timestamp).includes('T')) {
      timestamp = Date.parse(timestamp)
    }
    if (`${timestamp}`.length < 12) timestamp = timestamp * 1000
    const timer = new Date(timestamp - offsetGMT)
    // const offset = new Date().getTimezoneOffset()
    const yyyy = timer.getUTCFullYear() // 年
    const mm = timer.getUTCMonth() + 1 > 9 ? timer.getUTCMonth() + 1 : '0' + (timer.getUTCMonth() + 1) // 月
    const dd = timer.getUTCDate() > 9 ? timer.getUTCDate() : '0' + timer.getUTCDate() // 日
    const hh = timer.getUTCHours() > 9 ? timer.getUTCHours() : '0' + timer.getUTCHours() // 时
    const min = timer.getUTCMinutes() > 9 ? timer.getUTCMinutes() : '0' + timer.getUTCMinutes() // 分
    const ss = timer.getUTCSeconds() > 9 ? timer.getUTCSeconds() : '0' + timer.getUTCSeconds() // 秒
    let time = ''
    if (type == 0) {
      const lang = this.$store.state.LanguageCode
      if (lang == 'zh-cn' || lang == 'zh-tw' || lang == 'zh-hk') {
        const momen = now - timer
        // console.log(momen, 666)
        switch (true) {
          case momen >= 0 && momen < 600000:
            time = this.$t('20649')
            break
          case momen >= 600000 && momen < 3600000:
            time = this.$t('20647').replace('{0}', Math.round(momen / 60000))
            break
          case momen >= 3600000 && momen < 86400000:
            time = this.$t('20648').replace('{0}', Math.round(momen / 3600000))
            break
          case momen >= 86400000 && momen < 259200000:
            time = this.$t('20650').replace('{0}', Math.round(momen / 86400000))
            break
          case momen >= 259200000 && momen < 604800000:
            time = this.$t('21748').replace('{0}', 1)
            break
          default:
            time = `${yyyy}-${mm}-${dd} ${hh}:${min}`
            break
        }
      } else {
        time = `${yyyy}-${mm}-${dd} ${hh}:${min}`
      }
    } else if (type == 1) {
      time = `${yyyy}-${mm}-${dd}`
    } else if (type == 2) {
      time = `${hh}:${min}:${ss}`
    } else if (type == 3) {
      time = `${hh}:${min}`
    } else if (type == 4) {
      time = `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`
    } else if (type == 5) {
      time = `${yyyy}-${mm}-${dd}(UTC${timezoom}) ${hh}:${min}`
    }
    return time
  },
  ecoTime(timestamp, type = 0) {
    if (!timestamp) return
    if (String(timestamp).includes('T')) {
      timestamp = Date.parse(timestamp)
    }
    if (`${timestamp}`.length < 12) timestamp = timestamp * 1000
    const timer = new Date(timestamp - offsetGMT)
    const yyyy = timer.getUTCFullYear() // 年
    const curYear = new Date().getUTCFullYear() // 年
    const mm = timer.getUTCMonth() + 1 > 9 ? timer.getUTCMonth() + 1 : '0' + (timer.getUTCMonth() + 1) // 月
    const dd = timer.getUTCDate() > 9 ? timer.getUTCDate() : '0' + timer.getUTCDate() // 日
    const hh = timer.getUTCHours() > 9 ? timer.getUTCHours() : '0' + timer.getUTCHours() // 时
    const min = timer.getUTCMinutes() > 9 ? timer.getUTCMinutes() : '0' + timer.getUTCMinutes() // 分
    const ss = timer.getUTCSeconds() > 9 ? timer.getUTCSeconds() : '0' + timer.getUTCSeconds() // 秒
    let time = ''
    if (type == 0) {
      const lang = this.$store.state.LanguageCode
      if (lang == 'zh-cn' || lang == 'zh-tw' || lang == 'zh-hk') {
        const momen = now - timer
        switch (true) {
          case momen < 60000:
            time = this.$t('20647').replace('{0}', 1)
            break
          case momen >= 60000 && momen < 3600000:
            time = this.$t('20647').replace('{0}', Math.round(momen / 60000))
            break
          case momen >= 3600000 && momen < 86400000:
            time = this.$t('20648').replace('{0}', Math.round(momen / 3600000))
            break
          case momen >= 86400000 && momen < 259200000:
            time = this.$t('20650').replace('{0}', Math.round(momen / 86400000))
            break
          case momen >= 259200000 && curYear == yyyy:
            time = `${mm}-${dd}`
            break
          default:
            time = `${yyyy}-${mm}-${dd}`
            break
        }
      } else {
        const momen = now - timer
        switch (true) {
          case momen >= 0 && momen < 60000:
            time = '1m'
            break
          case momen >= 60000 && momen < 3600000:
            time = Math.round(momen / 60000) + 'm'
            break
          case momen >= 3600000 && momen < 86400000:
            time = Math.round(momen / 3600000) + 'h'
            break
          case momen >= 86400000 && momen < 259200000:
            time = Math.round(momen / 86400000) + 'd'
            break
          case momen >= 259200000 && curYear == yyyy:
            time = `${mm}-${dd}`
            break
          default:
            time = `${yyyy}-${mm}-${dd}`
            break
        }
      }
    } else if (type == 1) {
      time = `${yyyy}-${mm}-${dd}`
    } else if (type == 2) {
      time = `${hh}:${min}:${ss}`
    } else if (type == 3) {
      time = `${hh}:${min}`
    } else if (type == 4) {
      time = `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`
    } else if (type == 5) {
      time = `${yyyy}-${mm}-${dd} ${hh}:${min}`
    }
    return time
  },
  commentsTime(timestamp) {
    if (!timestamp) return
    if (String(timestamp).includes('T')) {
      timestamp = Date.parse(timestamp)
    }
    if (`${timestamp}`.length < 12) timestamp = timestamp * 1000
    const timer = new Date(timestamp - offsetGMT)
    const yyyy = timer.getUTCFullYear() // 年
    const mm = timer.getUTCMonth() + 1 > 9 ? timer.getUTCMonth() + 1 : '0' + (timer.getUTCMonth() + 1) // 月
    const dd = timer.getUTCDate() > 9 ? timer.getUTCDate() : '0' + timer.getUTCDate() // 日
    let time = ''
    const momen = now - timer
    switch (true) {
      case momen >= 0 && momen < 600000:
        time = this.$v('刚刚')
        break
      case momen >= 600000 && momen < 3600000:
        time = this.$v('{0}分钟前').replace('{0}', Math.round(momen / 60000))
        break
      case momen >= 3600000 && momen < 86400000:
        time = this.$v('{0}小时前').replace('{0}', Math.round(momen / 3600000))
        break
      case momen >= 86400000 && momen < 172800000:
        time = this.$v('昨天')
        break
      case momen >= 172800000 && momen < 259200000:
        time = this.$v('{0}天前').replace('{0}', Math.round(momen / 86400000))
        break
      case momen >= 259200000 && momen < 604800000:
        time = this.$v('{0}周内').replace('{0}', 1)
        break
      default:
        time = `${yyyy}-${mm}-${dd}`
        break
    }
    return time
  },
  setStarIcon(score) {
    try {
      let html = ''
      if (score && !isNaN(score)) {
        score = Number(score) + 1
        if (score > 10) {
          score = 10
        }
        const newScore = parseInt(score / 2)
        if (newScore > 0) {
          for (let i = 0; i < newScore; i++) {
            html += "<i class='iconfont icon-a-1'></i>"
          }
        }
        let empty = 0
        if (score % 2 >= 1) {
          empty = 1
          html += "<i class='iconfont icon-star-empty'></i>"
        }
        const hfi = 5 - (newScore + empty)
        for (let s = 0; s < hfi; s++) {
          html += "<i class='iconfont icon-star-empty-1'></i>"
        }
      }
      return html
    } catch {
      return ''
    }
  },
  setStarIcon2(score, color = 'rgba(0, 0, 0, 0.2)') {
    // 详情页
    try {
      let html = ''
      if (score && !isNaN(score)) {
        score = Number(score) + 1
        if (score > 10) {
          score = 10
        }
        const newScore = parseInt(score / 2)
        if (newScore > 0) {
          for (let i = 0; i < newScore; i++) {
            html += "<i class='iconfont icon-a-1'></i>"
          }
        }
        let empty = 0
        if (score % 2 >= 1) {
          empty = 1
          html += "<i class='iconfont icon-star-empty'></i>"
        }
        const hfi = 5 - (newScore + empty)
        for (let s = 0; s < hfi; s++) {
          html += `<i style='color:${color};' class='iconfont icon-star-filled1'></i>`
        }
      }
      return html
    } catch {
      return ''
    }
  },
  alternate() {
    // 设置页面的meta这块的alternate
    let lang = []
    const name = this.$route.name
    if (name == 'lang-wikilist.html') {
      const alllang = [
        {
          lang: 'en',
          hreflang: 'en'
        },
        {
          lang: 'zh-cn',
          hreflang: 'zh-Hans'
        },
        {
          lang: 'zh',
          hreflang: 'zh-Hant'
        }
      ]
      lang = [...alllang]
    } else if (name == 'newinfo' || name == 'lang-information-id' || name == 'lang-discover-id' || name == 'lang-best-id' || name == 'lang-rankings.html' || name == 'lang-videoshow-id' || name == 'lang-video.html' || name == 'lang-video-id' || name == 'shixun.html' || name == 'lang-shixun-id' || name == 'jiangtang.html' || name == 'lang-jiangtang-id' || name == 'zhishi.html' || name == 'lang-zhishi-id') {
      lang = []
    } else if (name == 'lang-word-id') {
      // 文字版交易商只显示zh-cn和zh
      const alllang = [
        {
          lang: 'zh-cn',
          hreflang: 'zh-Hans'
        },
        {
          lang: 'zh',
          hreflang: 'zh-Hant'
        }
      ]
      lang = [...alllang]
    } else if (name == 'lang-learnlist.html' || name == 'lang-learnlist-pre-school.html' || name == 'lang-learnlist-elementary.html' || name == 'lang-learnlist-middleschool.html' || name == 'lang-learnlist-summer-camp.html' || name == 'lang-learnlist-highschool.html' || name == 'lang-learnlist-undergraduate.html' || name == 'lang-learnlist-graduation.html') {
      const alllang = [
        {
          lang: 'en',
          hreflang: 'en'
        },
        {
          lang: 'zh-cn',
          hreflang: 'zh-Hans'
        },
        {
          lang: 'zh',
          hreflang: 'zh-Hant'
        },
        {
          lang: 'vi',
          hreflang: 'vi'
        },
        {
          lang: 'ru',
          hreflang: 'ru'
        },
        {
          lang: 'es',
          hreflang: 'es'
        },
        {
          lang: 'th',
          hreflang: 'th'
        },
        {
          lang: 'fil',
          hreflang: 'tl'
        }
      ]
      lang = [...alllang]
    } else {
      const alllang = [
        {
          lang: 'en',
          hreflang: 'en'
        },
        {
          lang: 'zh-cn',
          hreflang: 'zh-Hans'
        },
        {
          lang: 'zh',
          hreflang: 'zh-Hant'
        },
        {
          lang: 'ja',
          hreflang: 'ja'
        },
        {
          lang: 'id',
          hreflang: 'id'
        },
        {
          lang: 'vi',
          hreflang: 'vi'
        },
        {
          lang: 'ru',
          hreflang: 'ru'
        },
        {
          lang: 'es',
          hreflang: 'es'
        },
        {
          lang: 'th',
          hreflang: 'th'
        },
        {
          lang: 'fil',
          hreflang: 'tl'
        },
        {
          lang: 'it',
          hreflang: 'it'
        },
        {
          lang: 'fr',
          hreflang: 'fr'
        },
        {
          lang: 'pt',
          hreflang: 'pt'
        },
        {
          lang: 'ko',
          hreflang: 'ko'
        },
        {
          lang: 'de',
          hreflang: 'de'
        },
        {
          lang: 'hi',
          hreflang: 'hi'
        },
        {
          lang: 'tr',
          hreflang: 'tr'
        },
        {
          lang: 'ar',
          hreflang: 'ar'
        }
      ]
      lang = [...alllang]
    }
    const arrLink = []
    const href = this.$store.state.allHost.includes('?') && !this.$store.state.allHost.includes('revelation') && !this.$store.state.allHost.includes('exposure/slist') ? this.$store.state.allHost.substring(0, this.$store.state.allHost.indexOf('?')) : this.$store.state.allHost
    let hrefT = ''
    lang.forEach((item) => {
      hrefT = href.replace(this.$store.state.LanguageCode, item.lang)
      arrLink.push({ rel: 'alternate', hreflang: item.hreflang, href: hrefT })
    })
    if (name != 'lang-best-id' && name != 'lang-rankings.html' && name != 'lang-videoshow-id' && name != 'lang-video.html' && name != 'lang-video-id' && name != 'shixun.html' && name != 'lang-shixun-id' && name != 'jiangtang.html' && name != 'lang-jiangtang-id' && name != 'zhishi.html' && name != 'lang-zhishi-id' && name != 'lang-word-id') {
      arrLink.push({
        rel: 'alternate',
        hreflang: 'x-default',
        href: href.replace(this.$store.state.LanguageCode, 'en')
      })
    }
    return arrLink
  },
  canonical() {
    // 设置页面的meta这块的canonical
    const arrLink = []
    // let href = (this.$store.state.allHost.includes('?') && !this.$store.state.allHost.includes('revelation') && !this.$store.state.allHost.includes('exposure/slist')) ? (this.$store.state.allHost.substring(0, this.$store.state.allHost.indexOf('?'))) : this.$store.state.allHost
    // if (href.includes('wikifx2') || href.includes('test')) {
    //   href = href.replace('wikifx2', 'wikifx').replace('test', 'www')
    // }
    let href = ''
    if (this.$store.state.allHost.includes('fxeyema.com')) {
      // let href = (this.$store.state.allHost.includes('?') && !this.$store.state.allHost.includes('revelation') && !this.$store.state.allHost.includes('exposure/slist')) ? (this.$store.state.allHost.substring(0, this.$store.state.allHost.indexOf('?'))) : this.$store.state.allHost
      // if (href.includes('wikifx2') || href.includes('test')) {
      //   href = href.replace('wikifx2', 'wikifx').replace('test', 'www')
      // }
      href = `https://www.fxeyema.com${this?.$route?.fullPath}`
    } else {
      href = `${this.getwwwDomain(this.$store.state)}${this?.$route?.fullPath}`
    }
    arrLink.push({ rel: 'canonical', href })
    return arrLink
  },
  // 根据id获取用户信息
  async getUserInfo(fn) {
    if (!this.$store.state.user.userId) return null
    const LanguageCode = this.$store.state.LanguageCode
    const CountryCode = this.$store.state.CountryCode
    const {
      succeed = false,
      extra = '',
      result = {}
    } = await this.$api.home
      .getUserinfo({
        UserId: this.$store.state.user.userId,
        ApplicationType: 7,
        CountryCode,
        LanguageCode,
        Ppl: 7,
        Poy: 1
      })
      .catch(() => {
        fn && fn()
      }) // 2.使用id获取用户信息
    if (!succeed) return this.$message.error(extra) // 数据错误
    // console.log('result', result)
    this.$store.commit('setUserInfo', result)
  },
  // 根据id获取用户信息
  async getUserinfoKh(fn) {
    // 客户端
    if (!this.$store.state.user.userId) return null
    const LanguageCode = this.$store.state.LanguageCode
    const CountryCode = this.$store.state.CountryCode
    const {
      succeed = false,
      extra = '',
      result = {}
    } = await this.$api.home
      .getUserinfoKh({
        UserId: this.$store.state.user.userId,
        ApplicationType: 7,
        CountryCode,
        LanguageCode,
        Ppl: 7,
        Poy: 1
      })
      .catch(() => {
        fn && fn()
      }) // 2.使用id获取用户信息
    if (!succeed) return this.$message.error(extra) // 数据错误
    // console.log('result', result)
    this.$store.commit('setUserInfo', result)
  },
  langType() {
    // 语言类别判断就是长短语言--短语言为true，长语言为false
    let bool = false
    if (this.$store.state.LanguageCode == 'zh-cn' || this.$store.state.LanguageCode == 'zh' || this.$store.state.LanguageCode == 'zh-tw' || this.$store.state.LanguageCode == 'zh-hk') bool = true
    else bool = false
    return bool
  },
  homelangType() {
    // 首页判断字体是否为斜体长短语言--短语言为true，长语言为false
    let bool = false
    if (this.$store.state.LanguageCode == 'zh-cn' || this.$store.state.LanguageCode == 'zh-tw' || this.$store.state.LanguageCode == 'zh-hk' || this.$store.state.LanguageCode == 'vi' || this.$store.state.LanguageCode == 'th') bool = true
    else bool = false
    return bool
  },
  async gettraderName(codes) {
    // 历史记录返回
    const data = await this.$api.dealer
      .gettraderbycodes({
        codes: codes.join()
      })
      .then((res) => {
        const traderArr = []
        codes.forEach((item) => {
          const arr = res && res.filter((t) => t.code == item)
          traderArr.push(...arr)
        })
        return traderArr
        // this.fxeyedirectArr = [...traderArr]
      })
    return data
  },
  vpslogo() {
    // 根据语种判断vps-logo
    const lang = ['zh-cn', 'zh']
    if (lang.includes(this.$store.state.LanguageCode)) {
      return `https://resources1.interface003.com/web20/img/home/traderBg.png?v=${new Date()}`
    } else {
      return `https://resources1.interface003.com/web20/img/rankingList/iocn-bg.png?v=${new Date()}`
    }
  },
  setlogin() {
    // 判断是否登录
    if (!this.$store.state.user.userId) {
      this.$Toast({
        message: '还未登录',
        position: 'middle',
        onClose: () => {
          this.$store.commit('loginClose', true)
        }
      })
      return false
    }
    return true
  },
  getJysName(localName, name, dot = '', localFirst = true, isMulti = false) {
    const samename = localName == name || (localName && name && localName.trim() == name.trim())
    if (isMulti && !samename && localName && name) {
      if (localFirst) {
        return (localName ? localName + '' : '') + (dot || '') + (name ? name + '' : '')
      } else {
        return (name ? name + '' : '') + (dot || '') + (localName ? localName + '' : '')
      }
    } else if (localFirst) {
      return localName ? localName + '' : name
    } else {
      return name ? name + '' : localName
    }
  },
  adcountfn(hitsInfo) {
    // 广告统计 hitsType, jumpType = '0', activityType = '1', url = '', tCode = '', iCode = '', adId = '', tabType = '',
    // console.log(hitsInfo, 7778)
    // tCode: jumpType == '0' || jumpType == '2' ? '' : tCode, // 文章或交易商或直播房间CODE
    // iCode: jumpType == '0' || jumpType == '2' ? (hitsType == '904' ? iCode : '') : iCode, // 文章或交易商或直播房间CODE，用于兼容code
    // hitsType, // 广告统计类型（不是广告类型），22推流，18轮播，59对联，900顶部广告，901底部广告，902布告栏
    // jump: jumpType, // 跳转类型，0无跳转，1交易商详情页，2外链接，3新闻文章详情，4实勘，10直播，11直播列表，12模拟交易
    // url, // 跳转链接，为空时不传
    // activityType, // 广告分类，1广告，2活动，4新闻文章，有值就传，没有就传1
    // jumpType,
    // adId,
    // tabType,
    this.$api.home
      .invokev3(
        {
          hitsInfo
        },
        {
          Routes: 'fxad$hitsv2'
        }
      )
      .then((res) => {
        console.log(res, 1111)
      })
      .catch(() => {
        console.log('广告统计')
      })
  },
  async datastatistics(type, url, code = '', callback) {
    // 统计type为1--浏览模式默认；type为2---广告点击；3---点击模式官方网址；4---开户网址；5---品专官方网址；6---品专开户地址;7---品专默认
    let spots = 5
    if (type == '1' && !this.$store.state.allHost.includes('brand=1')) spots = 5
    else if (type == '2')
      spots = 3 // 广告
    else if (type == '3' && !this.$store.state.allHost.includes('brand=1')) spots = 1
    else if (type == '4' && !this.$store.state.allHost.includes('brand=1')) spots = 4
    else if (type == '5' && this.$store.state.allHost.includes('brand=1')) spots = 11
    else if (type == '6' && this.$store.state.allHost.includes('brand=1')) spots = 12
    else if (type == '7' && this.$store.state.allHost.includes('brand=1')) spots = 10
    else if (type == '21') spots = 21
    else if (type == '20') spots = 20
    else if (type == '22') spots = 22
    else if (type == '23') spots = 23
    const param = {
      userid: this.$store.state.user.userId ? this.$store.state.user.userId : '', // 用户标识
      equipId: this.$Cookie.get('wiki-bfp'),
      platform: 3, // 平台类型
      apptype: 0, // 客户端类型
      ip: this.$store.state.userIp, // 用户ip
      ver: '0', // 版本
      equipinfo: 0, // 客户端类型
      country: this.$store.state.CountryCode, // 当前国家
      lang: this.$store.state.LanguageCode, // 当前语言
      type: 1, // 浏览类型
      code, // 交易商code
      spots, // 点位类型 1网址 3广告 4开户网址 11品专网址 12品专开户网址
      url, // 对应网址
      jumpStatisticsUrl: this.$store.state.allHost
    }
    await this.$api.dealer.statistics(param).then((res) => {
      // console.log(res, 11235)
      // if (res && res.url) {
      //   if (type == '6' || type == '4' || type == '5' || type == '3') {
      //     const u = res.url.includes('http') ? res.url : `https://${res.url}`
      //     this.$refs.dealerhead.iframeval(u)
      //     this.tipstype = String(res.type)
      //   } else if (type == '20' || type == '21') {
      //     const u = res.url.includes('http') ? res.url : `https://${res.url}`
      //     this.$refs.primary.iframeval(u)
      //     this.tipstype = String(res.type)
      //   }
      // }
      callback(res)
    })
  },
  googlenav(arr, iskey = false) {
    // Google结构化面包屑
    if (!arr || arr.length == 0) {
      return {}
    }
    const google = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: []
    }
    const y = this.$store.state
    arr.forEach((item, index) => {
      if (item.type == 'a') {
        google.itemListElement.push({
          '@type': 'ListItem',
          position: index + 1,
          name: index == 0 ? 'WikiFX' : !item.translation ? (iskey ? this.$t(item.text) : this.$v(item.text)) : item.text,
          item: `https://${y.host}/${y.LanguageCode}${item.link}`
        })
      } else {
        google.itemListElement.push({
          '@type': 'ListItem',
          position: index + 1,
          name: !item.translation ? (iskey ? this.$t(item.text) : this.$v(item.text)) : item.text
        })
      }
    })
    // console.log(JSON.stringify(google), 9999)
    return google
  },
  islonglang() {
    // 判读是否为长语言
    const lang = ['zh-cn', 'zh']
    if (lang.includes(this.$store.state.LanguageCode)) return false
    return true
  },
  mdcountfn(obj) {
    // 埋点统计
    const previousPath = localStorage.getItem('previousPath') || '[]'
    const arr = JSON.parse(previousPath)
    const route = arr[1] || arr[0] || '\\'

    const bfp = this.$cookies.get('wiki-bfp') ? this.$cookies.get('wiki-bfp') : '822ca7b3261a0b2ec10c8cdabfb5a0ea'
    let base = `999,0,2,999,0,${bfp},0`
    if (this.$store.state.isWiki == '1') {
      base = `999,0,2,999,0,${bfp},0`
    } else if (this.$store.state.myCountry == 'cn') {
      base = `999,0,1,999,1,${bfp},1`
    } else {
      base = `999,0,2,999,0,${bfp},0`
    }

    const eventvalue = {
      userId: this.$store.state.user.userId || '',
      deviceId: base,
      languageCode: this.$store.state.LanguageCode,
      countryCode: this.$store.state.CountryCode,
      env: process.env.NODE_ENV === 'development' ? '测试环境' : '正式环境'
    }

    const param = {
      event_time: dayjs(new Date(now)).format('YYYY-MM-DD HH:mm:ss'),
      city: this.$store.state.curCity,
      platform: 'web',
      event_time_selected_timezone: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      selected_timezone: this.$store.state.curProvince,
      app_name: 'wikifx',
      event_value: JSON.stringify(eventvalue),
      BasicData: base,
      app_version: '2.0',
      ip: this.$store.state.userIp,
      state: '',
      region: '',
      user_agent: window?.navigator?.userAgent,
      pre_page: route,
      url: this.$store.state.allHost
    }

    this.$api.home
      .count3(
        {
          // 名片详情
          data: [JSON.stringify(Object.assign(param, obj))]
        },
        {
          Routes: 'netwon$report'
        }
      )
      .then((res) => {})
    console.log(window.navigator.userAgent, param, route)
  },

  matomofn(event, obj) {
    // matomo埋点
    const bfp = this.$cookies.get('wiki-bfp') ? this.$cookies.get('wiki-bfp') : '822ca7b3261a0b2ec10c8cdabfb5a0ea'
    let base = `999,0,2,999,0,${bfp},0`
    if (this.$store.state.isWiki == '1') {
      base = `999,0,2,999,0,${bfp},0`
    } else if (this.$store.state.myCountry == 'cn') {
      base = `999,0,1,999,1,${bfp},1`
    } else {
      base = `999,0,2,999,0,${bfp},0`
    }
    let str = ''
    for (const key in obj) {
      str += `&${key}=${obj[key]}`
    }
    window?._paq?.push([
      'trackEvent',
      `userid=${this.$store.state.user.userId}&basicdata=${base}&Langugecode=${this.$store.state.LanguageCode}&countryCode=${this.$store.state.CountryCode}${str}`,
      'Click',
      event
    ])
  },

  abBrokerDomain(url) {
    // const keywords = ['privacy.html' ,'/news.html', '/newsdetail/','original.html','industry.html','brokernews.html','wikilist.html','evaluation.html', 'authority.html']
    const keywords = ['/compare/', '/word/']
    return keywords.some((keyword) => url.includes(keyword))
  }
}

export default (context) => {
  context.$getBrokerDomain = currProject.getBrokerDomain
  context.$getwwwDomain = currProject.getwwwDomain
  context.$abBrokerDomain = currProject.abBrokerDomain
  Object.keys(currProject).forEach((item) => {
    Vue.prototype[item] = currProject[item]
  })
}

// function generateRandomString (length) { // 随机生成16位字符串
//   let result = ''
//   const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
//   const charactersLength = characters.length
//   for (let i = 0; i < length; i++) {
//     result += characters.charAt(Math.floor(Math.random() * charactersLength))
//   }
//   return result
// }

// function base64Encode (string) { // 生成base64格式
//   // 对非ASCII字符进行编码
//   const encodedString = encodeURIComponent(string)
//   // 将编码后的字符串转换为base64格式
//   const base64Encoded = btoa(encodedString)
//   return base64Encoded
// }
